import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog.jsx'
import { Button } from '@/components/ui/button.jsx'

export const ApproveDeleteDialog = ({ isDialogOpen, onClose, approveDelete, title = 'Approve Delete', subtitle = 'Are you sure you want to delete?' }) => {

    return (
        <Dialog open={isDialogOpen} onOpenChange={onClose}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>{subtitle}</DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <div className="flex justify-between gap-2">
                        <Button variant="outline" onClick={onClose}>Cancel</Button>
                        <Button variant="destructive" onClick={approveDelete}>Delete</Button>
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}